import React, { lazy, Suspense } from "react";
import "./CodeBlock.css";

// Lazy load syntax highlighter for better performance
const SyntaxHighlighter = lazy(() =>
  import("react-syntax-highlighter").then((module) => ({
    default: module.Prism,
  }))
);

// Lazy load the style
const loadStyle = () =>
  import("react-syntax-highlighter/dist/esm/styles/prism").then(
    (module) => module.vscDarkPlus
  );

const CodeBlock = ({ code, language = "javascript" }) => {
  const [style, setStyle] = React.useState(null);

  React.useEffect(() => {
    loadStyle().then(setStyle);
  }, []);

  if (!code) return null;

  return (
    <div className="cbx-code-block">
      <Suspense
        fallback={
          <pre className="cbx-code-block__fallback">
            <code>{code}</code>
          </pre>
        }
      >
        {style ? (
          <SyntaxHighlighter
            language={language}
            style={style}
            showLineNumbers
            wrapLines
            customStyle={{
              borderRadius: "0",
              padding: "20px",
              fontSize: "14px",
              margin: 0,
              background: "transparent",
            }}
          >
            {code}
          </SyntaxHighlighter>
        ) : (
          <pre className="cbx-code-block__fallback">
            <code>{code}</code>
          </pre>
        )}
      </Suspense>
    </div>
  );
};

export default React.memo(CodeBlock);
